// extracted by mini-css-extract-plugin
export default {"base":"Label_base__zC43U","error":"Label_error__2O5oU","required":"Label_required__SPsn8"};